import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem, Divider } from 'material-ui';
import moment from 'moment';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';
import Translate from 'translate';

import DeleteModal from 'components/HTMLElements/DeleteModal';
import NotificationsService from 'services/NotificationsService';
import {
  toggleAlertError,
  toggleLoading,
  deleteAllNotifications,
  deleteNotification
} from 'stores/actions/';

class Notifications extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      deleteModalOpened: false,
    };

    this.clearAll = this.clearAll.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
  }

  clearAll() {
    const { toggleAlertError, toggleLoading, deleteAllNotifications } = this.props;

    toggleLoading( true );
    NotificationsService.deleteNotifications().then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      deleteAllNotifications();
      if( this.props.confirmDelete ) this.setState( { deleteModalOpened: false } )
    } )
  }

  removeNotification( id ) {
    const { toggleAlertError, toggleLoading, deleteNotification } = this.props;

    toggleLoading( true );
    NotificationsService.deleteNotification( id ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      deleteNotification( id );
      if( this.props.confirmDelete ) this.setState( { deleteModalOpened: false } )
    } )
  }

  toggleDeleteModal( cb ) {
    this.deleteFn = cb;

    if( this.props.confirmDelete ) return this.setState( { deleteModalOpened: !this.state.deleteModalOpened } );
    return cb()
  }

  render() {
    const { data, confirmDelete, setActiveChannel, loadMoreNotifications, totalNotifications } = this.props;

    return (
      <div className="box-body box-body-notifications" id="notifications">
        {!!totalNotifications &&
        <div className="text-right">
          <button className="btn btn-sm btn-info"
                  onClick={() => this.toggleDeleteModal( this.clearAll )}><Translate id="clearAll"/>
          </button>
        </div>
        }

        {!totalNotifications &&
        <div className="text-muted justify-content-center align-middle text-center">
          <img className="img-fluid rounded-circle img80_80" src="assets/images/icons/notifications.png" alt="..."/>
          <h5><Translate id="noNewNotifications"/></h5>
          <p><Translate id="noNewNotificationsSubtitle"/></p>
        </div>
        }

        <InfiniteScroll
          pageStart={0}
          loadMore={loadMoreNotifications}
          hasMore={data.data.length < totalNotifications}
          loader={<div className="loader" key={0}><Translate id="loading"/>...</div>}
          useWindow={false}
        >
          <List>
            {_.map( data.data, ( notification, index ) => {
              return (
                <div key={index}>
                  <ListItem
                    primaryText={<div className="pt-3 px-2">
                      {notification.content === 'NEW_CHANNEL' && <Translate id="notification.newChannel"/>}
                      {notification.content === 'NEW_MESSAGE' && <Translate id="notification.newMessage"/>}
                      {notification.content === 'UPDATE_CHANNEL' && <Translate id="notification.updateChannel"/>}
                      {notification.content === 'ASSIGNED_CHANNEL' && <Translate id="notification.assignedChannel"/>}
                      {['UPDATE_CHANNEL', 'NEW_MESSAGE', 'NEW_CHANNEL', 'ASSIGNED_CHANNEL'].indexOf( notification.content ) === -1 &&
                      <div>{notification.content}</div>
                      }
                      <div className="text-small text-muted mt-3 row">
                        <div
                          className="col-md-7">{_.get( notification, 'channel.name' )}</div>
                        <div className="col-md-5 p-0">
                          {moment( notification.createdAt ).format( 'DD/MM/YYYY h:mm A' )}
                        </div>
                      </div>
                    </div>
                    }
                    onClick={() => setActiveChannel( _.isObject( notification.channel ) ? notification.channel.id : notification.channel )}
                    innerDivStyle={{
                      padding: 0,
                      marginBottom: '10px',
                      borderLeft: `5px solid ${notification.type === 'CHANNEL' || notification.type === 'MESSAGE' ? '#2e6c99' : '#77DEEE'}`,
                      borderRight: '1px solid #ccc',
                      borderBottom: '1px solid #ccc',
                      borderRadius: 5
                    }}
                  >
                    <div className="d-flex justify-content-between p-2"
                         style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
                      <div>
                        <i className="text-muted text-small fa fa-exclamation mr-1"/>
                        <span
                          className="text-muted text-small">
                          {notification.type === 'ASSIGNMENT' && <Translate id="assignment"/>}
                          {notification.type === 'UPDATE' && <Translate id="update"/>}
                          {notification.type === 'CHANNEL' && <Translate id="channel"/>}
                          {notification.type === 'MESSAGE' && <Translate id="message"/>}
                        </span>
                      </div>
                      <i className="fa fa-close mx-0 text-muted" style={{ width: 'auto' }}
                         onClick={( e ) => {
                           e.stopPropagation();
                           this.toggleDeleteModal( () => this.removeNotification( notification.id ) )
                         }}
                      />
                    </div>
                  </ListItem>

                </div>
              )
            } )}
          </List>
        </InfiniteScroll>

        {confirmDelete &&
        <DeleteModal label={<Translate id="sureToDelete"/>}
                     onConfirm={this.deleteFn}
                     opened={this.state.deleteModalOpened}
                     onToggle={this.toggleDeleteModal}
        />
        }
      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  confirmDelete: state.user.beforeDelete,
  totalNotifications: state.notifications.total
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  deleteAllNotifications: ( data ) => {
    dispatch( deleteAllNotifications( data ) );
  },
  deleteNotification: ( data ) => {
    dispatch( deleteNotification( data ) );
  }
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Notifications );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/Notifications/index.js